import ErrorReportRoot from "./ErrorReportRoot.vue"

export default ErrorReportRoot
